import {
  HeaderTabs,
  type TabWithIndicatorProps,
} from "@/components/Navigation/HeaderTabs";
import { defaultNS, useTranslation } from "@/lib/i18n";

export default function SoftwareHeaderTabs({
  id,
}: {
  id: string;
}) {
  const { t } = useTranslation(defaultNS, { keyPrefix: "common.list" });

  const links: TabWithIndicatorProps[] = [
    {
      to: "/software/$id",
      activeOptions: { exact: true },
      params: { id },
      children: t("overview"),
    },
    {
      to: "/software/$id/users",
      params: { id },
      children: t("software.userAccounts"),
    },
    {
      to: "/software/$id/activity-monitoring",
      params: { id },
      children: t("software.activityMonitoring"),
    },
    {
      to: "/software/$id/detail",
      params: { id },
      children: t("software.detail"),
    },
    {
      to: "/software/$id/architecture",
      params: { id },
      children: t("software.architecture"),
    },
    {
      to: "/software/$id/contracts-cost",
      params: { id },
      children: t("software.contractsAndCost"),
    },
    {
      to: "/software/$id/rule-and-policy",
      params: { id },
      children: t("software.rulesAndPolicy"),
    },
    {
      to: "/software/$id/settings",
      params: { id },
      children: t("software.settings"),
    },
  ];

  return <HeaderTabs tabs={links} />;
}
